import Vue from 'vue'
import Vuex from 'vuex'
Vue.use(Vuex)

const store = new Vuex.Store({
  state: {
    usermain: {
      curOrg: {},
      loggedIn: false
    }
  },
  mutations: {
    setCurOrg (state, curOrg) {
      state.usermain.curOrg = curOrg
    },
    setLoggedin (state, loggedIn) {
      state.usermain.loggedIn = loggedIn
    },
    reset (state) {
      state.usermain.curOrg = ''
      state.usermain.loggedIn = false
    }
  }
})

export default store




// WEBPACK FOOTER //
// ./src/components/webmaster/Store/vuex.js